import React from 'react';
import BeforeAfterSlider from 'react-before-after-slider';
import useResizeObserver from "use-resize-observer";
import { Link } from "react-router-dom";
import Header2 from '../Layout/Header2';
import bg2 from "../assets/images/123.jpg";
import img1 from "../assets/images/Icon-1.png";
import img2 from "../assets/images/Icon-2.png";
import img3 from "../assets/images/Icon.png";
import about1 from "../assets/images/Imgs.png";
import bg1 from "../assets/images/bg1.png";
import Logos from './Logos';
import "./slider.css";

export default function ImageReview() {
    const before = bg1;
    const after = bg2;
    const { ref, width = 1 } = useResizeObserver();

    return (
        <div className='bg-gradient-new-reverse'>
            <Header2 />
            <Logos />
            <section className="section pt-5" id="about">
                <div className="container" >
                    {/*  end row  */}
                    <div className="row align-items-center imgreverse">
                        <div className="col-lg-6" >
                            <div className='p-3' ref={ref} style={{ backgroundColor: "rgba(255, 255, 255, 0.12)", borderRadius: "12px" }}>
                                <BeforeAfterSlider
                                    before={before}
                                    after={after}
                                    width={width}
                                    height={600}
                                />
                                {/* <img src={about} alt="" style={{width:"90%"}}/> */}
                            </div>
                        </div>
                        {/*  end col  */}
                        <div className="col-lg-6" >

                            <div className="">

                                <p className=' Upgrade'>Upgrade your profile with 100 AI headshots for $15</p>
                                <p className="  inclusive">
                                    An all-inclusive solution for elevating your professional Linkedin
                                    profiles,captivationg visuals on your  personal social media accounts, and everyting
                                    in between!
                                </p>
                                <div className="me-5 flex-shrink-0 d-none d-lg-block">

                                    <Link
                                        style={{ fontFamily: "Poppins", fontWeight: "700", borderRadius: "12px", fontSize: "20px", lineHeight: "20px" }}
                                        className=" btn btn-primary nav-btn"
                                        to="#"
                                    >
                                        CREATE YOURS NOW


                                    </Link>
                                </div>
                            </div>
                        </div>

                        {/*  end col  */}
                    </div>
                    {/*  end row  */}
                    <div className="row align-items-center justify-content-between" style={{ marginTop: "100px" }}>
                        <div className="col-lg-6">
                            <p className='whychoose'>Why choose us?</p>
                            <p className="craft">
                                Craft top-tier professional portraits to suit all your needs,
                                from a polished business headshot to  compelling content
                                marketing and even impressive offline collateral.
                            </p>



                            {/* End card */}
                            <div className="d-flex align-items-center" style={{ marginTop: "40px" }}>
                                <div className="flex-shrink-0">
                                    <img
                                        className="avatar-sm  img-fluid"
                                        src={img3}
                                        alt=""
                                    />
                                </div>
                                <div className="flex-grow-1 ms-3">
                                    <p className="mb-0 nomore"> No more photoshoots </p>
                                    <p className="save">Save on expensive photographers. Explore
                                        our hyper-realistic AI photos and elevate your visuals.</p>
                                </div>
                            </div>
                            <div className="d-flex align-items-center" style={{ marginTop: "40px" }}>
                                <div className="flex-shrink-0">
                                    <img
                                        className="avatar-sm img-fluid"
                                        src={img1}
                                        alt=""
                                    />
                                </div>
                                <div className="flex-grow-1 ms-3">
                                    <p className="mb-0 nomore">Download your photo's </p>
                                    <p className="save">Hnadpick and download
                                        favourites from your private album.</p>
                                </div>
                            </div>
                            <div className="d-flex align-items-center" style={{ marginTop: "40px" }}>
                                <div className="flex-shrink-0">
                                    <img
                                        className="avatar-sm  img-fluid"
                                        src={img2}
                                        alt=""
                                    />
                                </div>
                                <div className="flex-grow-1 ms-3">
                                    <p className="mb-0 nomore"> The best AI results in seconds</p>
                                    <p className="save">Custom AI model created just for your based
                                        an your uploaded images.</p>
                                </div>
                            </div>

                        </div>
                        {/*  end col  */}
                        <div className="col-lg-6">
                            <img src={about1} className="img-fluid" alt="" style={{ width: "90%" }} />
                        </div>
                        {/*  end col  */}
                    </div>
                    {/*  end row  */}

                    {/* End row */}
                </div>
                {/*  end container  */}
            </section>

        </div>
    )
}
